import { render, staticRenderFns } from "./App.vue?vue&type=template&id=23d81ca6&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=23d81ca6&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d81ca6')) {
      api.createRecord('23d81ca6', component.options)
    } else {
      api.reload('23d81ca6', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=23d81ca6&", function () {
      api.rerender('23d81ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pub/App.vue"
export default component.exports